import {
  LogoMain,
  LogoMainDark,
  LogoSplash,
  LogoSplashDark,
} from "../../../config/brandAssets";

interface BrandLogoProps {
  /** "splash" = login/auth logo · "main" = primary brand logo */
  variant?: "splash" | "main";
  className?: string;
  alt?: string;
}

// Active-theme brand logo that swaps to the dark-surface (white) variant in
// dark mode via Tailwind's `dark:` variant. Use this on surfaces whose
// background also reacts to `dark:` classes (e.g. the login panel) so the logo
// and its background always share the same light/dark signal. For themes that
// don't define dark variants, brandAssets falls back to the light logo.
export default function BrandLogo({
  variant = "splash",
  className = "",
  alt = "Logo",
}: BrandLogoProps) {
  const light = variant === "main" ? LogoMain : LogoSplash;
  const dark = variant === "main" ? LogoMainDark : LogoSplashDark;
  return (
    <>
      <img src={light} alt={alt} className={`${className} dark:hidden`} />
      <img src={dark} alt={alt} className={`hidden dark:block ${className}`} />
    </>
  );
}
